export const SIGN_OUT_TEXT = 'sign out';
